import { ActivatedRouteSnapshot } from '@angular/router';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Server } from './server';
import { UserService } from './user.service';

@Injectable()
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class ServerResolver {
  constructor(private userService: UserService) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(route: ActivatedRouteSnapshot): Observable<Server> {
    return this.userService.getServerDetail();
  }
}
